import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

const authTokenKey = 'auth_token';
const serviceUnavailableRoute = '/service-unavailable';

function setAuthToken(token, navigate) {
    localStorage.setItem(authTokenKey, token);

    navigate('/');
}

function getAuthToken() {
    return localStorage.getItem(authTokenKey);
}

function isAuthenticated() {
    return !!getAuthToken();
}

function logout() {
    localStorage.removeItem(authTokenKey);

    window.location.href = '/login';
}

function getErrorStatus(err) {
    return err?.response?.status ?? err?.status;
}

function isNetworkConnectionError(err) {
    return !err?.response && (err?.code === 'ERR_NETWORK' || err?.message === 'Network Error' || !!err?.request);
}

function redirectToServiceUnavailable() {
    if (window.location.pathname === serviceUnavailableRoute)
        return;

    window.location.href = serviceUnavailableRoute;
}

async function login(path, data, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {},) {
    await api.post(path, data, {
        headers: handleApiHeaders(authorized)
    })
    .then((response) => {
        if (!response.data.user.admin) {
            setMessage({ type: 'warning', text: 'Usuário ou senha incorretos.' });
            onFinally();
            return;
        }

        handleApiResponse(200, response, onSuccess, onError, onFinally);
        onFinally();
    })
    .catch((err) => {
        if (getErrorStatus(err) === 401) {
            setMessage({ type: 'warning', text: 'Usuário ou senha incorretos.' });
            onFinally();
            return;
        }

        handleApiError(err, setMessage, onError, onFinally, false);
    });
}

async function post(path, data, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {},) {
    await api.post(path, data, {
        headers: handleApiHeaders(authorized)
    })
    .then((response) => {
        handleApiResponse(200, response, onSuccess, onError, onFinally);
        onFinally();
    })
    .catch((err) => {
        handleApiError(err, setMessage, onError, onFinally);
    });
}

async function create(path, data, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {}) {
    await api.post(path, data, {
        headers: handleApiHeaders(authorized)
    })
    .then((response) => {
        handleApiResponse(201, response, onSuccess, onError, onFinally);
    })
    .catch((err) => {
        handleApiError(err, setMessage, onError, onFinally);
    });
}

async function put(path, data, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {}) {
    await api.put(path, data, {
        headers: handleApiHeaders(authorized)
    })
    .then((response) => {
        handleApiResponse(200, response, onSuccess, onError, onFinally);
    })
    .catch((err) => {
        handleApiError(err, setMessage, onError, onFinally);
    });
}

async function remove(path, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {}, data = undefined) {
    await api.delete(path, {
        headers: handleApiHeaders(authorized),
        data: data
    })
    .then((response) => {
        handleApiResponse(200, response, onSuccess, onError, onFinally);
    })
    .catch((err) => {
        handleApiError(err, setMessage, onError, onFinally);
    });
}

async function get(path, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {}, params = undefined) {
    await api.get(path, {
        headers: handleApiHeaders(authorized),
        params: params
    })
    .then((response) => {
        handleApiResponse(200, response, onSuccess, onError, onFinally);
    })
    .catch((err) => {
        handleApiError(err, setMessage, onError, onFinally);
    });
}

async function getBlob(path, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {}, params = undefined, onNotFound = () => {}) {
    await api.get(path, {
        responseType: 'blob',
        headers: handleApiHeaders(authorized),
        params: params
    })
    .then((response) => {
        handleApiResponse(200, response, onSuccess, onError, onFinally);
    })
    .catch((err) => {
        if (getErrorStatus(err) === 404) {
            onNotFound();
            onFinally();
            return;
        }

        handleApiError(err, setMessage, onError, onFinally);
    });
}

function handleApiHeaders(authorized) {
   let headers = {};
    if (!!authorized)
        headers.Authorization = `Bearer ${getAuthToken()}`
    
    return headers;
}

function handleApiResponse(successStatus, response, onSuccess, onError, onFinally) {
    try {
        if (response.status !== successStatus) {
            onError('O servidor não retornou um status esperado.');
            onFinally();
            return;
        }

        onSuccess(response);
        onFinally();
    } catch (err) {
        onFinally();
        onError(err);
    }
}

function handleApiError(err, setMessage, onError, onFinally) {
    if (isNetworkConnectionError(err)) {
        onFinally();
        redirectToServiceUnavailable();
        return;
    }

    if (getErrorStatus(err) === 422) {
        setMessage({ type: 'warning', text: err.response.data[0].message });
        onFinally();
        return;
    }
    
    if (getErrorStatus(err) === 401) {
        setMessage({ type: 'error', text: 'Acesso negado.' });
        onFinally();
        logout();
        return;
    }

    onError(err);
    onFinally();
}

export { setAuthToken, isAuthenticated, logout, login, create, post, put, remove, get, getBlob };